import { render, staticRenderFns } from "./AccountingTransactionShow.vue?vue&type=template&id=2d945f0e&"
import script from "./AccountingTransactionShow.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports